/**
 * The type of the action which signals a request for an interpreter.
 *
 * {
 *     type: REQUEST_INTERPRETER,
 *     roomName: string
 * }
 */
export const REQUEST_INTERPRETER = 'REQUEST_INTERPRETER';
